export default __webpack_public_path__ + "static/editor-d39ece3410c261c6f705f6a87970516e.svg";